import React from 'react';
import { FAQItem } from '../components/FAQItem';
import { HelpCircle } from 'lucide-react';
export const FAQ = () => {
  const faqs = [{
    question: 'How Can I Contact Customer Support?',
    answer: 'You can reach us by email at rawalraj2057@gmail.com or by phone at 0800 055 4969. Our support team is available Monday to Friday from 9 am to 5 pm. Messages received outside these hours will be responded to on the next working day.'
  }, {
    question: 'When Does My Service Plan Start and End?',
    answer: 'Your Prismedge coverage begins as soon as your payment is confirmed. For example, if you purchase a 12-month plan on 15 July, your protection lasts until 23:59 on 14 July the following year. Your plan activates immediately after payment clears, and a confirmation email will be sent straight away. No further action is needed on your part.'
  }, {
    question: 'How Do I Request a Repair?',
    answer: 'Contact Prismedge at 0800 055 4969 or email rawalraj2057@gmail.com. We typically schedule repair appointments within 24 to 48 hours.'
  }, {
    question: 'What Does "Unlimited Repairs" Mean?',
    answer: 'You may request unlimited repair visits and technician time for all essential appliances covered under your Prismedge plan. Please note: Appliances older than 10 years, accidental or liquid damage, and general wear and tear not caused by mechanical or electrical faults are excluded.'
  }, {
    question: 'Can I Cancel My Service Plan and Get a Refund?',
    answer: 'Yes. You can cancel within 14 days of purchase for a full refund, provided no repair work has started. Cancellations made between days 15 and 28 may be eligible for a partial refund, at our discretion, taking into account any services already rendered. No refunds are offered after 28 days. To cancel, email rawalraj2057@gmail.com or call 0800 055 4969 with your order number. Refunds will be processed to your original payment method within 7 to 10 working days.'
  }, {
    question: 'What Appliances and Faults Are Covered?',
    answer: 'Our plans cover mechanical and electrical faults on registered appliances (e.g., breakdowns, faulty components). Excluded items include accidental or liquid damage, unregistered appliances, and appliances exceeding the age limit of 10 years.'
  }, {
    question: 'How Quickly Can I Book an Appointment?',
    answer: 'We aim to respond within 48 hours to arrange a visit. Most local repairs are booked within 3 to 5 working days. For remote locations or busy periods, scheduling may take longer, but we will discuss alternative timings with you.'
  }, {
    question: 'Do You Cover the Whole UK?',
    answer: 'Yes. Our services cover England, Scotland, and Wales. Please check availability for remote postcodes before purchasing.'
  }];
  return <div className="w-full" data-id="element-290">
      {/* Hero Section */}
      <div className="bg-primary py-16 md:py-24 w-full" data-id="element-291">
        <div className="container mx-auto px-4" data-id="element-292">
          <div className="flex items-center justify-center mb-6" data-id="element-293">
            <HelpCircle className="text-white mr-3" size={36} data-id="element-294" />
            <h1 className="text-3xl md:text-5xl font-bold text-white" data-id="element-295">
              Frequently Asked Questions
            </h1>
          </div>
          <p className="text-xl text-white/90 max-w-3xl mx-auto text-center" data-id="element-296">
            Find answers to common questions about our appliance repair services
            and service plans.
          </p>
        </div>
      </div>
      {/* FAQ Section */}
      <section className="py-16 bg-light" data-id="element-297">
        <div className="container mx-auto px-4" data-id="element-298">
          <div className="max-w-3xl mx-auto bg-white rounded-lg shadow-md p-6 md:p-8" data-id="element-299">
            <div className="space-y-1" data-id="element-300">
              {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isDefaultOpen={index === 0} data-id="element-301" />)}
            </div>
          </div>
        </div>
      </section>
      {/* Still Have Questions */}
      <section className="py-16 bg-white" data-id="element-302">
        <div className="container mx-auto px-4 text-center" data-id="element-303">
          <h2 className="text-3xl font-bold text-primary mb-6" data-id="element-304">
            Still Have Questions?
          </h2>
          <p className="text-lg text-gray-600 mb-8 max-w-3xl mx-auto" data-id="element-305">
            If you couldn't find the answer you were looking for, please don't
            hesitate to contact our friendly customer service team.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-306">
            <a href="/contact-us" className="bg-primary hover:bg-primary/90 text-white font-bold py-3 px-8 rounded-md text-lg transition-colors" data-id="element-307">
              Contact Us
            </a>
            <a href="tel:08000554969" className="bg-secondary hover:bg-secondary/90 text-white font-bold py-3 px-8 rounded-md text-lg transition-colors" data-id="element-308">
              Call 0800 055 4969
            </a>
          </div>
        </div>
      </section>
    </div>;
};